<template>
  <div>
    <v-row  style="margin-top:0px;">
      <v-col md="3">
        <SellerDashboard></SellerDashboard>
      </v-col>
      <v-col md="9">
        <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
          <v-card-title>
            <b class="prfont fontst">Add Products</b>
          </v-card-title>
          <v-row>
          <v-col md="3"></v-col>
          <v-col md="6">
            <v-form ref="form"  lazy-validation>
              <v-text-field 
                label="Product Name"
                prepend-icon="mdi-domain"
                type="text"
                class="form-control prfont cr"
                id="productname"
                v-model="product.productname"
                :rules="nameRules"
                required
              />

              <v-text-field
                prepend-icon="mdi-currency-inr"
                label="Product Cost"
                type="text"
                 class="form-control prfont cr"
                id="productcost"
                v-model="product.productcost"
                :rules="costRules"
                required
              />
              <v-radio-group  class="prfont cr" 
                v-model="product.instock"
                prepend-icon="mdi-image-broken"
                label="Instock"
                row
                :rules="stockRules"
              >
                <v-radio label="Yes" value="true"  class="prfont cr"></v-radio>
                <v-radio label="No" value="false"  class="prfont cr"></v-radio>
              </v-radio-group>
            

              <v-text-field
                prepend-icon="mdi-clipboard-text"
                label="Description"
                type="text"
                 class="form-control prfont cr"
                id="description"
                v-model="product.description"
                :rules="descRules"
                required
              />
           <br>
              <label class="prfont cr">Specifications</label>
              <!-- <div v-for = "j in count"> -->
              <!-- {{qwe}} -->
              <v-row v-for="(item,i) in qwe" :key="i">
                <v-col cols="12" sm="6" md="5">
                  <v-textarea label="Name" v-model="item.name" class="prfont cr"></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-textarea label="Value" v-model="item.value" class="prfont cr">></v-textarea>
                </v-col>
                <v-col md="2">
                  <span>
                    <strong @click="update" style="font-size:26px;padding-left:10px;">+</strong>
                  </span>
                </v-col>
              </v-row>
             

            
                 <!-- {{highlights}} -->
                   <v-row  v-for="char in highlights" :key="char.id">
                <v-text-field
                prepend-icon="mdi-clipboard-text"
                label="Highlights"
                type="text"
                 class="form-control prfont cr"
                 v-model="char.charas"
                :rules="descRules"
                required
              />
                <v-col md="2">
                  <span>
                    <strong @click="updatee" style="font-size:26px;padding-left:10px;">+</strong>
                  </span>
                    <span>
                    <strong @click="remove" style="font-size:26px;padding-left:10px;">-</strong>
                  </span>
                </v-col>
              </v-row>
               <label for="unit" class="prfont cr">Unit Type</label>
              <v-select
                prepend-icon="mdi-hexagon-outline"
                :items="unittypes"
                v-model="product.unit"
                :rules="unitRules"
              ></v-select>
              <label for="unit" class="prfont cr">Tax Type</label>
              <v-select
                prepend-icon="mdi-dice-3"
                :items="taxtypes"
                v-model="tax"
                :rules="typeRules"
              ></v-select>
              <label for="tax" class="prfont cr">Tax Amount</label>
              <v-text-field
                prepend-icon="mdi-currency-inr"
                type="text"
                disabled
                 class="form-control prfont cr"
                id="tax"
                v-model="product.tax"
                required
                :rules="taxRules"
              />

              <label for="unit" class="prfont cr">Commission</label>
              <v-text-field
                prepend-icon="mdi-dice-1"
                type="text"
                disabled
                 class="form-control prfont cr"
                id="comission"
                v-model="product.comission"
                :rules="commRules"
              />
              <label for="unit" class="prfont cr">Price</label>
              <v-text-field
                prepend-icon="mdi-currency-inr"
                type="text"
                disabled
                 class="form-control prfont cr"
                id="price"
                :rules="priceRules"
                v-model="product.price"
              />

              <v-radio-group class="prfont cr"
                v-model="product.isseasonal"
                prepend-icon="mdi-image-broken"
                label="Isseasonal"
                row
              >
                <v-radio label="Yes" value="true" class="prfont cr"> </v-radio>
                <v-radio label="No" value="false" class="prfont cr"></v-radio>
              </v-radio-group>
           
<div v-if="product.isseasonal == 'true'" >
              <v-radio-group class="prfont cr" 
                v-model="product.isinseason"
                prepend-icon="mdi-image-broken"
                label="isinseason"
                row
              >
                <v-radio label="Yes" value="true" class="prfont cr"></v-radio>
                <v-radio label="No" value="false" class="prfont cr"></v-radio>
              </v-radio-group>
            


</div>
<div v-if="product.isinseason  == 'true' && product.isseasonal == 'true' ">
     <label for="unit" class="prfont cr">Season Info</label>
              <v-text-field
                prepend-icon="mdi-clipboard-text"
                type="text"
           
                 class="form-control prfont cr"
                id="price"
               
                v-model="product.seasoninfo"
              />
</div>
              <v-layout wrap justify-center>
                <v-flex xs12 md12 pt-2 text-center>
                  <v-btn
                    rounded
                    :disabled="false"
                    width="500px"
                    class="text-capitalize hh prfont"
                    dark
                    :ripple="false"
                    color="#26af82"
                    @click="addProduct"
                  >Submit</v-btn>
                </v-flex>
              </v-layout>
              <br />

              <!-- <v-card-actions>
                <v-btn color="red" text @click="signindialog = false">Cancel</v-btn>
                <v-spacer />
                <v-btn color="#0e4e35" text @click="reginit">Signup</v-btn>
              </v-card-actions>-->
            </v-form>
          </v-col>
          </v-row>
        </v-card>
      </v-col>

      <br />
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import SellerDashboard from "@/components/common/SellerDashboard";
export default {
  components: { SellerDashboard },
  data() {
    return {
      data: {},
      visible: false,
      it: "",
      product: {
        productname: null,
        price: null,
        instock: null,
        description: null,
        unit: null,
        productcost: null,
        comission: null,
        tax: null,
        taxid: null,
        name: null,
        value: null
      },
      highlights:[
        {
          charas:"",
        }
      ],
      specification: [],
      qwe: [
        {
          name: "",
          value: ""
          // id:'',
        }
      ],

      isseasonal: null,
      tax: null,
      taxid: null,
      taxtype: [],
      taxtypes: [],
      taxtypesid: [],
      instocks: ["yes", "no"],
      unittypes: ["Count", "Kg", "gm", "litre"],
      gender: ["Male", "Female"],
      msg: null,
      nameRules: [v => !!v || "required"],
      costRules: [v => !!v || "required"],
      descRules: [v => !!v || " required"],
      stockRules: [v => !!v || " required"],
      taxRules: [v => !!v || " required"],
      commRules: [v => !!v || " required"],
      priceRules: [v => !!v || " required"],
      unitRules: [v => !!v || " required"],
      typeRules: [v => !!v || " required"]
    };
  },

  mounted: function() {
    this.getTax();
    this.calcTax();
  },
  watch: {
    tax: function() {
      if (this.product.productcost != null) {
        for (var j = 0; j < this.taxtype.length; j++) {
          if (this.tax === this.taxtypes[j]) {
            this.taxid = this.taxtypesid[j];
            this.product.taxid = this.taxtypesid[j];
          }
        }
        this.calcTax();
        // console.log(this.taxid)
      } else {
        alert("Please Provide Product Cost");
      }
    }
  },
  methods: {
    getTax() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/tax/all",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          // console.log(response)
          this.visible = false;
          this.taxtype = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.taxtype.length; i++) {
            var ty = this.taxtype[i].name;
            var tyid = this.taxtype[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.taxtypes = temp;
          this.taxtypesid = tempid;
        })
        .catch(err => {
          console.log(err);
          this.visible = false;
        });
    },
    calcTax() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/product/calculateprice",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          taxid: this.taxid,
          productcost: this.product.productcost
        }
      })
        .then(response => {
          // console.log(response)
          this.product.tax = response.data.data.tax;
          this.product.price = response.data.data.price;
          this.product.comission = response.data.data.commision;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
          this.visible = false;
        });
    },
    update() {
      this.qwe.push({
        name: null,
        value: null
        // id:null
      });
    },
      updatee() {
      this.highlights.push({
       charas:null
        
      });
    },
     add (index) {
      this.highlights.push({
        charas: null,
      })
    },
     remove (index) {
      this.highlights.splice(index, 1)
    },
    addProduct(evt) {
      if (this.$refs.form.validate()) {
        evt.preventDefault();
        this.visible = true;
        if (this.product.instock === "true") {
          this.product.instock = true;
        }
        if (this.product.instock === "false") {
          this.product.instock = false;
        }
       
        var chars = []
      for (var i = 0; i < this.highlights.length; i++) {
        chars.push(this.highlights[i].charas)
      }
        this.product.productcost = Number(this.product.productcost);
        this.product.specifications = this.qwe;
        this.product.highlights=chars;
        console.log(this.product.highlights)
        var data = {};
        data = this.product;
        console.log(data);
        axios({
          method: "POST",
          url: "/Product/Add",
          headers: {
            // 'x-auth-token': localStorage.getItem('token')
            "x-auth-token": localStorage.getItem("token")
          },
          data: data
        })
          .then(response => {
            if (response.data.status == true) {
              this.id = response.data.id;
              this.msg = "Product added successfully";
              this.$dlg.alert(
                this.msg,
                () => {
                  // this.$router.push("/ImageUpload/" + this.vid);
                  this.$router.push("/AddShipping/" + this.id);
                  // this.$router.push("/productlist/");
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
        // .then(response => {

        //   alert('Product Added Success')
        //   this.$router.push({name: 'productlist'})
        //   this.msg = response.data.msg
        //   this.visible = false
        // }).catch(err => {
        //   console.log(err)
        //   this.msg = err.response.data.msg
        //   this.visible = false
        // })
      }
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.prfont {
  font-family: "Montserrat";
}
.cr{
  color:black;
}
</style>